var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSuccess16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.99999998,0.499999977 C3.85786436,0.499999977 0.499999977,3.85786436 0.499999977,7.99999998 C0.499999977,12.1421356 3.85786436,15.5 7.99999998,15.5 C12.1421356,15.5 15.5,12.1421356 15.5,7.99999998 C15.5,3.85786436 12.1421356,0.499999977 7.99999998,0.499999977 Z M12.245,6.29499999 L7.295,11.245 C7.10743174,11.4327771 6.85290924,11.5382867 6.5875,11.5382867 C6.32209075,11.5382867 6.06756825,11.4327771 5.87999999,11.245 L5.16999999,10.535 L3.75499999,9.12 C3.50223458,8.8672346 3.40351845,8.49882099 3.49603701,8.15353703 C3.58855557,7.80825306 3.85825305,7.53855558 4.20353701,7.44603703 C4.54882098,7.35351847 4.91723459,7.45223459 5.16999999,7.705 L6.585,9.12 L10.83,4.87999999 C11.2207415,4.48925854 11.8542585,4.48925854 12.245,4.88 C12.6357415,5.27074146 12.6357415,5.90425853 12.245,6.29499999 L12.245,6.29499999 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CBA-Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconSuccess16",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons/32/iconStatusApprove32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)",
    fill: "#5AE18C"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8-color"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uD83C\\uDFA8-Colour/brand/green",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccess16);
export default __webpack_public_path__ + "static/media/iconSuccess16.9b4b0731c2762b1b72cc25a4cdf46561.svg";
export { ForwardRef as ReactComponent };